var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// ./~/victory-box-plot/~/lodash/_nativeCreate.js
// module id = ./node_modules/victory-box-plot/node_modules/lodash/_nativeCreate.js
// module chunks = 1